export default "__VITE_ASSET__e1re1GVh__"